import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { getSubdomain } from '@/lib/subdomain'
import { MainApp } from '@/pages/home/MainApp'
import { StatsApp } from '@/pages/stats/StatsApp'
import { LiveApp } from '@/pages/live/LiveApp'
import { AdminApp } from '@/pages/admin/AdminApp'

function App() {
  const subdomain = getSubdomain()

  // Redirect to actual subdomain in production when using query param
  useEffect(() => {
    const hostname = window.location.hostname
    const isProduction = hostname !== 'localhost' && hostname !== '127.0.0.1'
    
    if (isProduction) {
      const params = new URLSearchParams(window.location.search)
      const requestedSubdomain = params.get('subdomain')
      
      if (requestedSubdomain && ['stats', 'live', 'admin'].includes(requestedSubdomain)) {
        // Redirect to the actual subdomain
        window.location.href = `https://${requestedSubdomain}.n0n3.com${window.location.pathname}`
        return
      }
    }
  }, [])

  return (
    <BrowserRouter>
      {subdomain === 'admin' && <AdminApp />}
      {subdomain === 'stats' && <StatsApp />}
      {subdomain === 'live' && <LiveApp />}
      {(subdomain === 'main' || subdomain === 'localhost') && <MainApp />}
    </BrowserRouter>
  )
}

export default App
